/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const chatbot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M14.364 8.955a1.589 1.589 0 0 1 0 2.545M1.636 8.955a1.588 1.588 0 0 0 0 2.545M8 4.818a5.091 5.091 0 1 1 0 10.183A5.091 5.091 0 0 1 8 4.818Zm0 0V2.91m0 0a.954.954 0 1 1 0-1.908.954.954 0 0 1 0 1.908Zm-2.26 7.84h.023m4.473 0h.022"
    />
  </svg>
)
export default chatbot
